import { Injectable } from '@angular/core';
import {
  StaffsAndUsersServiceProxy,
  StaffUserRoleDto,
  StaffUserRoleInput,
} from '@shared/service-proxies/service-proxies';

@Injectable({
  providedIn: 'root',
})
export class UserRolesFacade {
  constructor(
    private _staffsAndUsersServiceProxy: StaffsAndUsersServiceProxy
  ) {}

  updateStaffUserRoleDetails(staff) {
    let params = new StaffUserRoleInput({
      userId: staff.userId,
      staffUserRole: new StaffUserRoleDto({
        staffRoleId: parseInt(staff.staffUserRole.staffRoleId, 10),
        staffRoleName: staff.staffUserRole.staffRoleName,
        staffRoleDisplayName: staff.staffUserRole.staffRoleDisplayName
      }),
    });
    return this._staffsAndUsersServiceProxy.updateStaffUserRoleDetails(params);
  }
}
